<template>
  <section class="recovery-password">
    <v-card class="elevation-12 card">
      <v-toolbar flat class="card-header">
        <v-icon>mdi-lock-question</v-icon>
        <v-toolbar-title>Esqueci a senha</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="card-content">
        <p>Digite seus dados abaixo e receba as instruções para acessar sua conta em seu email.</p>

        <v-alert outline color="error" icon="mdi-alert" :value="formRecoveryFailed">
          {{formRecoveryFailedMessage}}
        </v-alert>

        <v-form>
          <v-text-field
            v-model="username"
            name="username"
            label="Usuário"
            type="text" />

          <v-text-field
            v-model="cpf"
            name="cpf"
            label="CPF"
            type="text"
            :mask="masks.cpf" />
        </v-form>
      </v-card-text>

      <v-card-actions class="card-action">
        <v-spacer />
        <v-btn
          large
          color="success"
          :disabled="formRecoveryLoading"
          :loading="formRecoveryLoading"
          @click.stop="recovery(username, cpf)"
        >
          Enviar instruções
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>

    <nav slot="navigation" class="card-navigation">
      <v-layout align-center justify-center>
        <v-btn
          class="link"
          flat
          small
          color="primary"
          :to="'/autenticacao/entrar'"
        >
          <v-icon left>mdi-account-circle</v-icon>
          <span class="text">Voltar ao login</span>
        </v-btn>
      </v-layout>
    </nav>

    <dialog-instructions-password />
  </section>
</template>

<script>
import passwordService from '@/services/PasswordService';
import DialogInstructionsPassword from '@/components/authentication/password/recovery/DialogInstructionsPassword';
import masks from '@/mixins/masks';

export default {
  name: 'FormRecoveryPassword',
  components: {
    DialogInstructionsPassword,
  },
  data() {
    return {
      username: '',
      cpf: '',
      formRecoveryLoading: false,
      formRecoveryFailed: false,
      formRecoveryFailedMessage: '',
      masks,
    };
  },
  methods: {
    recovery(username, cpf) {
      this.formRecoveryFailed = false;
      this.formRecoveryLoading = true;
      this.$store.dispatch('toggleInstructionsPassword', false);

      passwordService.recovery(username, cpf)
        .then((response) => {
          this.formRecoveryLoading = false;
          this.formRecoverySuccess = JSON.stringify(response);
          this.$store.dispatch('toggleInstructionsPassword', true);
        })
        .catch((errors) => {
          this.formRecoveryLoading = false;
          this.formRecoveryFailed = true;
          this.formRecoveryFailedMessage = errors.response.data.errors;
        });
    },
    confirmInstructions() {
      this.$store.dispatch('toggleInstructionsPassword', false);
      this.$router.push({ name: 'FormAuthentication' });
    },
  },
};
</script>

<style scoped lang="scss">
.recovery-password {
  .card-content {
    padding: 1rem 2rem;
    max-width: 420px;
  }
  .card-action {
    padding: 1rem 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/password/FormRecoveryPassword.vue